module.exports = require("@swa-ui/authentication/src/components/MissingInformationForm/MissingInformationForm.module.scss");